<div class="wrapper">
  <dx-load-indicator
    id="medium-indicator"
    height="40"
    width="40"
  ></dx-load-indicator>
</div>
